import ContractorListContext from "context/contractor-list";
import { useGetContractors, useGetContractorsPagination } from "hooks/useRequest/contractors/contractors";
import { useGetServiceType } from "hooks/useRequest/form";
import { useGetCities } from "hooks/useRequest/location/location";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import { FC, memo, useCallback, useMemo, useState } from "react";
import lastProject from "services/last-project";
import selectedContractorService from "services/selected-contractor.service";
import ItemSkeleton from "./card/skeleton";
import styles from "./index.module.scss";
import DOMPurify from 'dompurify';

const ContractorCard = dynamic(() => import("./card"), {
  ssr: false,
  loading: () => <ItemSkeleton />
});
const SelectedContractorModal = dynamic(() => import("./selected-modal"))




const Contractors: FC<ReturnType<typeof useGetContractors>> = ({
  data,
  error,
  fetchNextPage,
  isFetchingNextPage,
  hasNextPage,
  isSuccess,
  isLoading
}) => {
  const router = useRouter()

  const [values, setValues] = useState({
    selected: selectedContractorService.getContractors() ?? [],
    selectedBefore: typeof window !== "undefined" && (Boolean(localStorage.getItem("selectedContractorBefore")) ?? false)
  })

  const { data: installmentsData } = useGetContractorsPagination({
    params: {
      page: 1,
      limit: 10,
      workInInstallments: true
    },
    options: {
      enabled: Boolean(router.query.workInInstallments)
    }
  })

  const flatData = useMemo(() => data?.pages.flatMap(page => page.data ?? []) ?? [], [data])
  const flatMeta = useMemo(() => data?.pages.flatMap(page => page.meta ?? []) ?? [], [data])
  const sanitizedDescription = DOMPurify.sanitize(flatMeta?.[0]?.contractorPageDescription || "")


  /////////////////////////////////////////////// queries //////////////////////////////////////////////////////
  const { data: cities } = useGetCities({
    enabled: true
  });

  const { data: serviceTypes } = useGetServiceType({
    options: {
      enabled: Boolean(lastProject.getId())
    }
  });

  const skeletonLoadingItem = useCallback((items: number) => {
    return (
      <div className="flex flex-wrap gap-15 mb-md">
        {Array.from({ length: items }, (v, i) =>
          <ItemSkeleton key={i} />
        )}
      </div>
    )
  }, [])





  return (
    <ContractorListContext.Provider value={{ values, setValues }}>
      <section className={`container ${styles.specialists_container}`}>
        <header className={styles.wrapper_num_of_specialists}>
          <div className={styles.divider_line}></div>
          <div className={styles.text_section}>
            {data?.pages[0]?.meta?.count} متخصص
          </div>
          <div className={styles.divider_line}></div>
        </header>

        {
          (lastProject.getId()) &&
          <SelectedContractorModal />
        }

        {
          error ?
            <h3 className="flex jcc">
              متاسفانه در دریافت اطلاعات مشکلی بوجود آمده است
            </h3>
            : isLoading ? skeletonLoadingItem(9) :
              (isSuccess && data) ?
                <>
                  <article className={styles.wrapper_items}>
                    {[...installmentsData?.data ?? [], ...flatData].map(res => (
                      <ContractorCard
                        key={res._id}
                        data={res}
                        citiesData={cities?.data}
                        serviceTypesData={serviceTypes?.data}
                      />
                    ))}
                  </article>

                  {hasNextPage && (
                    <section className={styles.load_more}>
                      {isFetchingNextPage ? (
                        skeletonLoadingItem(9)
                      ) : (
                        <div className={styles.action__load_more}>
                          <button
                            onClick={() => fetchNextPage()}
                            className="btn primary__btn mt-lg"
                          >
                            نمایش بیشتر
                          </button>
                        </div>
                      )}
                    </section>
                  )}

                  {sanitizedDescription ?
                    <article className="html_descriptions">
                      <div dangerouslySetInnerHTML={{
                        __html: sanitizedDescription
                      }} />
                    </article>
                    :
                    <></>
                  }
                </>
                :
                skeletonLoadingItem(20)
        }
      </section>
    </ContractorListContext.Provider>
  );

};

export default memo(Contractors);